import actionTypes from "_constants/actionTypes";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ACTUAL_YEAR_DATA:

      return {
        ...state,
        actualYear: action.payload,
        actualYearError: undefined,
      };

    case actionTypes.GET_ACTUAL_YEAR_ERROR:
      return {
        ...state,
        actualYearError: action.payload,
        actualYear: undefined,
      };
    case actionTypes.CLEAN_CHECK_CODE:
      return {
        ...state,
        checkCodeCenter: undefined,
        checkCodeCenterError: undefined,
      };
    case actionTypes.CHECK_CODE_DATA:
      return {
        ...state,
        checkCodeCenter: action.payload,
        checkCodeCenterError: undefined,
      };

    case actionTypes.CHECK_CODE_ERROR:
      return {
        ...state,
        checkCodeCenterError: action.payload,
        checkCodeCenter: undefined,
      };

    case actionTypes.CLEAN_REGISTER_USER:
      return {
        ...state,
        registerUser: undefined,
        registerUserError: undefined,
      };

    case actionTypes.REGISTER_USER_DATA:
      return {
        ...state,
        registerUser: action.payload,
        registerUserError: undefined,
      };

    case actionTypes.REGISTER_USER_ERROR:
      return {
        ...state,
        registerUser: undefined,
        registerUserError: action.payload,
      };

    case actionTypes.CLEAN_EMAIL_VERIFICATION:
      return {
        ...state,
        emailValid: undefined,
        emailError: undefined,
      };

    case actionTypes.LOGIN_DATA:
      return {
        ...state,
        error: null,
        user: action.payload,
        test:true
      };
    case actionTypes.LOGIN_ERROR:
      return {
        ...state,
        user: null,
        error: action.payload,
      };
    case actionTypes.FORGOTPASSWORD_DATA:
      return {
        ...state,
        forgot: action.payload,
      };
    case actionTypes.FORGOTPASSWORD_ERROR:
      return {
        ...state,
        forgotError: action.payload,
      };
    case actionTypes.RESETPASSWORD_DATA:
      return {
        ...state,
        reset: action.payload,
      };
    case actionTypes.RESETPASSWORD_ERROR:
      return {
        ...state,
        resetError: action.payload,
      };

    case actionTypes.GET_USER_DATA:
      return {
        ...state,
        userDataProfile: action.payload,
      };
    case actionTypes.GET_USER_ERROR:
      return {
        ...state,
        userDataError: action.payload,
      };
    case actionTypes.TUTOR_VALIDATED:
      return {
        ...state,
        tutorValidated: true,
      };
    case actionTypes.TUTOR_VALIDATED_ERROR:
      return {
        ...state,
        tutorValidated: false,
      };
      case actionTypes.TUTORS_RETRIEVED:
        return {
          ...state,
          tutorInformationList: action.payload,
          tutorInformationListError: false,

        };
      case actionTypes.TUTORS_RETRIEVED_ERROR:
        return {
          ...state,
          tutorInformationListError: true,
        };
    default:
      return state;
  }
};
